/** @format */

import { useMutation } from "@tanstack/react-query";
import service from "../service/service";

const useSaveEconomicIndicator = () =>
  useMutation({
    mutationKey: ["saveEconomicIndicator"],
    mutationFn: economicIndicatorData => {
      let api__data = {
        reportDate: economicIndicatorData.reportDate,
        regionId: economicIndicatorData.regionId,
        productLineId: economicIndicatorData.productLineId,
        imagePath: economicIndicatorData.imagePath,
        title: economicIndicatorData.title,
        id: economicIndicatorData.id
      }
      return service.saveEconomicIndicator(api__data)
    },
  });

export default useSaveEconomicIndicator;
